// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { APPBaseElement } from './APPBaseElement';
import { UIPage } from '../../../../../com/MetaPattern/MDA/MD/UIModel/UIPage';
import { MenuSet } from './MenuSet';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 菜单项 实体类
 * 菜单项
 */
export class MenuItem extends APPBaseElement {
  /** 图标 : 图标地址 */
  private _icon: string;

  /** 设置：图标 */
  public get icon() {
    return this._icon;
  }

  /** 获取：图标 */
  public set icon(value: string) {
    this._icon = value;
  }

  /** 是否启用 : 是否启用 */
  private _isValid: boolean;

  /** 设置：是否启用 */
  public get isValid() {
    return this._isValid;
  }

  /** 获取：是否启用 */
  public set isValid(value: boolean) {
    this._isValid = value;
  }

  /** 页面 的ID */
  private _page_ID: string;

  /** 获取：页面 的ID */
  public get page_ID() {
    return this._page_ID;
  }

  /** 设置：页面 的ID */
  public set page_ID(value: string) {
    this._page_ID = value;
  }

  /** 页面  */
  private _page: UIPage;

  /** 获取：页面  */
  public get page() {
    return this._page;
  }

  /** 设置：页面  */
  public set page(value: UIPage) {
    this._page = value;
    if (value !== null) {
      this.page_ID = value.id;
    } else {
      this.page_ID = '';
    }
  }

  /** 菜单集 的ID */
  private _menuSet_ID: string;

  /** 获取：菜单集 的ID */
  public get menuSet_ID() {
    return this._menuSet_ID;
  }

  /** 设置：菜单集 的ID */
  public set menuSet_ID(value: string) {
    this._menuSet_ID = value;
  }

  /** 菜单集  */
  private _menuSet: MenuSet;

  /** 获取：菜单集  */
  public get menuSet() {
    return this._menuSet;
  }

  /** 设置：菜单集  */
  public set menuSet(value: MenuSet) {
    this._menuSet = value;
    if (value !== null) {
      this.menuSet_ID = value.id;
    } else {
      this.menuSet_ID = '';
    }
  }

  constructor() {
    super();
    this._icon = '';
    this._isValid = true;
    this._page_ID = '';
    this._page = null;
    this._menuSet_ID = '';
    this._menuSet = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: MenuItem, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.icon = element.icon;
      this.isValid = element.isValid;
      this.page_ID = element.page_ID;
      if (hasReference && element.page !== null) {
        this.page = element.page;
      }
      this.menuSet_ID = element.menuSet_ID;
      if (hasReference && element.menuSet !== null) {
        this.menuSet = element.menuSet;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.icon = json.Icon;
    this.isValid = json.IsValid;
    this.page_ID = json.Page_ID;
    // if (json.Page !== null) {
    //   this.page = UIPage.Create(json.Page);
    // }
    this.menuSet_ID = json.MenuSet_ID;
    // if (json.MenuSet !== null) {
    //   this.menuSet = MenuSet.Create(json.MenuSet);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Icon = this.icon;
    json.IsValid = this.isValid;
    json.Page_ID = this.page_ID;
    json.MenuSet_ID = this.menuSet_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'icon', '图标', EnumDataType.String, this.icon, true, '图标地址', '', '');
    context.addRow('基本属性', 'isValid', '是否启用', EnumDataType.Bool, this.isValid, true, '是否启用', '', '');
    context.addRow('基本属性', 'page', '页面', EnumDataType.Reference, this.page, true, '菜单绑定的页面', 'UIPage', 'PGRowUIPageValue');
    return context;
  }

  static Create(json: any): MenuItem {
    const menuItem = new MenuItem();
    menuItem.Deserialize(json);
    menuItem.json = json;
    return menuItem;
  }
}
